export enum OnboardingChapter {
  Introduction = 'Introduction',
  Assessment = 'Assessment',
  GameIntroduction = 'GameIntroduction'
}
